import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../pages/home/views/Home';
import Cosmetics from "@/pages/cosmetics/views/Cosmetics";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/cosmetics',
        name: 'Cosmetics',
        component: Cosmetics
    },
    {
        path: '/impressum',
        name: 'Impressum',
        component: () => import(/* webpackChunkName: "imprint" */ '@/pages/imprint/views/Impressum')
    },
    {
        path: '/datenschutz',
        name: 'Datenschutz',
        component: () => import(/* webpackChunkName: "privacy-policy" */ '@/pages/privacy-policy/views/Datenschutz')
    },
    {
        path: '/service/kosmetik',
        redirect: '/cosmetics'
    },
    {
        path: '*',
        redirect: '/'
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
